import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import { fullNameSchema } from '../../../definitions/sharedSchema';
import {
  dobUI,
  fullNameUI,
  genderUI,
  vetRelationshipUI,
} from '../../../definitions/sharedUI';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['primary-info-title--personal'];
const INPUT_LABEL = content['primary-input-label'];
const HINT_TEXT = content['primary-hint-label'];

const { fullName, date, gender, vetRelationship } = FULL_SCHEMA.definitions;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    primaryFullName: fullNameUI({ label: INPUT_LABEL, labelAlt: HINT_TEXT }),
    primaryDateOfBirth: dobUI(INPUT_LABEL),
    primaryGender: genderUI(INPUT_LABEL),
    primaryVetRelationship: vetRelationshipUI(INPUT_LABEL),
  },
  schema: {
    type: 'object',
    required: [
      'primaryFullName',
      'primaryDateOfBirth',
      'primaryVetRelationship',
    ],
    properties: {
      primaryFullName: fullNameSchema(fullName),
      primaryDateOfBirth: date,
      primaryGender: gender,
      primaryVetRelationship: vetRelationship,
    },
  },
};
